import React, { Component } from "react";
import ToggleViewProps from './ToggleViewProps';
import ToggleViewStyle from "./ToggleViewStyle";
import TranslationView from "../Translation/TranslationView";

export default class ToggleView extends Component<ToggleViewProps> {

    private _style = new ToggleViewStyle();

    render() {
        const { selected } = this.props;
        const backgroundColor = selected ? '#2FC3C0' : '#D6DCE5';
        const color = selected ? '#FFFFFF' : '#000000';
        return (
            <div key={this.props.text} style={{ ...this._style.background, backgroundColor }} onClick={() => this.props.onClick()}>
                <TranslationView style={{ ...this._style.text, color }}>
                    {this.props.text}
                </TranslationView>
            </div>
        );  
    }
}